
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.5 24h-14A1.5 1.5 0 010 22.5v-21A1.5 1.5 0 011.5 0h7a1.5 1.5 0 01.9.3l.02.01 7 5a.4.4 0 01.06.06A1.5 1.5 0 0117 6.5v16a1.5 1.5 0 01-1.5 1.5zM1.5 1a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h14a.5.5 0 00.5-.5v-16a.5.5 0 00-.2-.4l-.02-.02A.5.5 0 0015.5 6h-5A1.5 1.5 0 019 4.5v-3a.5.5 0 00-.5-.5zm8.5.96V4.5a.5.5 0 00.5.5h3.76z"}}),_c('path',{attrs:{"d":"M13.5 10h-10a.5.5 0 010-1h10a.5.5 0 010 1zm0 4h-10a.5.5 0 010-1h10a.5.5 0 010 1zm0 4h-10a.5.5 0 010-1h10a.5.5 0 010 1zm8 6a1.48 1.48 0 01-1.37-.9l-1.04-3.7a2.55 2.55 0 01-.09-.67V1.5A1.5 1.5 0 0120.5 0h2A1.5 1.5 0 0124 1.5v17.23a2.48 2.48 0 01-.1.67l-1 3.64a1.5 1.5 0 01-1.4.96zm-1-23a.5.5 0 00-.5.5v17.23a1.5 1.5 0 00.06.4l1 3.64a.48.48 0 00.44.23.49.49 0 00.46-.3l.98-3.57a1.52 1.52 0 00.06-.4V1.5a.5.5 0 00-.5-.5z"}}),_c('path',{attrs:{"d":"M23.5 6h-4a.5.5 0 010-1h4a.5.5 0 010 1z"}})])
          )
        }
      }
    